import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more-vertical",
  "use": "icon-more-vertical-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more-vertical\"><path d=\"M512 458.667a53.333 53.333 0 1 0 0 106.666 53.333 53.333 0 1 0 0-106.666zM512 149.333A53.333 53.333 0 1 0 512 256.00000001a53.333 53.333 0 1 0 0-106.66700001zM512 767.99999999a53.333 53.333 0 1 0 0 106.66700001A53.333 53.333 0 1 0 512 767.99999999z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/more-vertical.svg
// module id = eIeF
// module chunks = 65